var _g, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 135,
    viewBox: "0 0 120 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9677_40249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 100H35C32.3478 100 29.8043 98.9464 27.9289 97.0711C26.0536 95.1957 25 92.6522 25 90V30C25 27.3478 26.0536 24.8043 27.9289 22.9289C29.8043 21.0536 32.3478 20 35 20H75C77.6522 20 80.1957 21.0536 82.0711 22.9289C83.9464 24.8043 85 27.3478 85 30V70",
    stroke: "#5A5F60",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8359 95.333C69.8359 97.3685 70.2369 99.3841 71.0158 101.265C71.7948 103.145 72.9365 104.854 74.3758 106.293C75.8151 107.732 77.5238 108.874 79.4043 109.653C81.2849 110.432 83.3004 110.833 85.3359 110.833C87.3714 110.833 89.387 110.432 91.2675 109.653C93.1481 108.874 94.8568 107.732 96.2961 106.293C97.7354 104.854 98.8771 103.145 99.6561 101.265C100.435 99.3841 100.836 97.3685 100.836 95.333C100.836 93.2975 100.435 91.282 99.6561 89.4014C98.8771 87.5209 97.7354 85.8122 96.2961 84.3729C94.8568 82.9335 93.1481 81.7918 91.2675 81.0129C89.387 80.2339 87.3714 79.833 85.3359 79.833C83.3004 79.833 81.2849 80.2339 79.4043 81.0129C77.5238 81.7918 75.8151 82.9335 74.3758 84.3729C72.9365 85.8122 71.7948 87.5209 71.0158 89.4014C70.2369 91.282 69.8359 93.2975 69.8359 95.333Z",
    stroke: "#5A5F60",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3359 89.333V96.2219",
    stroke: "#5A5F60",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3359 102.222V102.239",
    stroke: "#5A5F60",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3359 54.666H70.0026",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3359 58.666H63.3359",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 54.4441C40 54.1494 40.1171 53.8668 40.3254 53.6584C40.5338 53.4501 40.8164 53.333 41.1111 53.333H45.5556C45.8502 53.333 46.1329 53.4501 46.3412 53.6584C46.5496 53.8668 46.6667 54.1494 46.6667 54.4441V58.8886C46.6667 59.1832 46.5496 59.4659 46.3412 59.6742C46.1329 59.8826 45.8502 59.9997 45.5556 59.9997H41.1111C40.8164 59.9997 40.5338 59.8826 40.3254 59.6742C40.1171 59.4659 40 59.1832 40 58.8886V54.4441Z",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3359 74.4453H70.0026",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3359 79.1113H63.3359",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 74.4441C40 74.1494 40.1171 73.8668 40.3254 73.6584C40.5338 73.4501 40.8164 73.333 41.1111 73.333H45.5556C45.8502 73.333 46.1329 73.4501 46.3412 73.6584C46.5496 73.8668 46.6667 74.1494 46.6667 74.4441V78.8886C46.6667 79.1832 46.5496 79.4659 46.3412 79.6742C46.1329 79.8826 45.8502 79.9997 45.5556 79.9997H41.1111C40.8164 79.9997 40.5338 79.8826 40.3254 79.6742C40.1171 79.4659 40 79.1832 40 78.8886V74.4441Z",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3359 34.666H70.0026",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3359 38.666H63.3359",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 34.4441C40 34.1494 40.1171 33.8668 40.3254 33.6584C40.5338 33.4501 40.8164 33.333 41.1111 33.333H45.5556C45.8502 33.333 46.1329 33.4501 46.3412 33.6584C46.5496 33.8668 46.6667 34.1494 46.6667 34.4441V38.8886C46.6667 39.1832 46.5496 39.4659 46.3412 39.6742C46.1329 39.8826 45.8502 39.9997 45.5556 39.9997H41.1111C40.8164 39.9997 40.5338 39.8826 40.3254 39.6742C40.1171 39.4659 40 39.1832 40 38.8886V34.4441Z",
    stroke: "#5A5F60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 60,
    cy: 129.4,
    rx: 60,
    ry: 5.4,
    fill: "#5A5F60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9677_40249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/Option.2ea690a6bb048ef3c8f2b2d50f889496.svg";
export { ForwardRef as ReactComponent };